export default __webpack_public_path__ + "static/thehub-lg@2x-ff9807e717997e869f62bd01d82d66a3.png";